import { z } from 'zod';
import { expectType, zDocument } from './model.js';
export const DIRECT_MESSAGE_MAX_LENGTH = 1000;
export const zDirectMessage = zDocument.extend({
    type: z.literal('directMessage'),
    from: z.string(),
    to: z.string(),
    message: z.string().max(DIRECT_MESSAGE_MAX_LENGTH),
    read: z.string()
});
expectType({});
expectType({});
export const EmptyDirectMessage = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    type: 'directMessage',
    from: '',
    to: '',
    message: '',
    read: ''
};
